/* eslint-disable no-nested-ternary */
import * as vp from 'vopay';
import { Formik } from 'formik';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { buildVerificationRows } from './VerificationForm.helper';
import { useLayout } from '../../../../providers/Layout.provider';
import styles from '../AccountVerification.module.scss';

const { Box, TextField, ErrorText, Button } = vp;

type DefaultValuesProps = {
  Amount1: string;
  Amount2: string;
};

type VerificationHandler = {
  verifyAccount: (values: DefaultValuesProps) => void;
};

type VerificationFormProps = {
  handlers: VerificationHandler;
  errorMessage: string;
  setErrorMessage: (message: string) => void;
};

type FC = FunctionComponent<VerificationFormProps>;

const VerificationForm: FC = (props: VerificationFormProps) => {
  const { handlers, errorMessage, setErrorMessage } = props;
  const { color } = useLayout();
  const VerificationRow = buildVerificationRows();

  const defaultValues = {
    Amount1: '',
    Amount2: '',
  };
  const { t } = useTranslation('translations', { keyPrefix: 'VerifyAmount' });
  const autoInputFocus = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { maxLength, value, name } = e.target;

    const fieldIndex = name.substr(6);
    const fieldIntIndex = parseInt(fieldIndex, 10);

    const numericValue = parseFloat(value);
    if (!Number.isNaN(numericValue) && Number.isFinite(numericValue)) {
      if (value.length >= maxLength) {
        if (fieldIntIndex < 2) {
          const nextfield = document.querySelector(`input[name=Amount${fieldIntIndex + 1}]`);
          if (nextfield !== null) {
            (nextfield as HTMLElement)?.focus();
            e.target.value = '';
          }
        }
      }
    }
  };

  return (
    <Formik initialValues={defaultValues} onSubmit={handlers.verifyAccount}>
      {({ values, handleChange, handleBlur, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className={styles.formContainer}>
            <Box gap="sm">
              <div className={styles.num}>$0.</div>
              {VerificationRow.map(({ id, preset, placeholder }) => (
                <div key={id} className={styles.numberContainer}>
                  <TextField
                    key={id}
                    name={id}
                    variant="lined"
                    width="100%"
                    height="100%"
                    maxLength={1}
                    borderColor={errorMessage !== '' ? '#AC201B' : ''}
                    value={values[id]}
                    preset={preset}
                    onBlur={handleBlur}
                    placeholder={placeholder}
                    onChange={(e) => {
                      handleChange(e);
                      setErrorMessage('');
                      autoInputFocus(e);
                    }}
                    onFocus={(e) => {
                      e.target.placeholder = '';
                    }}
                  />
                </div>
              ))}
            </Box>
            <div className={styles.errorContainer}>
              <ErrorText error={errorMessage} />
            </div>
          </div>
          <Box>
            <Button
              id="verify-amount-btn"
              label={`${t('verify')}`}
              width="100%"
              type="submit"
              background={color}
              textColor={vp.getContrastColor(color)}
              textSize={16}
              fontWeight={500}
              fontUnit="px"
              size="xlg"
              round
              noShadow
              bold
            />
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default VerificationForm;
